import React from 'react';
import Marquee from 'react-css-marquee';
import { colors } from '../styles';
import { Info } from '@mui/icons-material';

import { useAuth } from '../context/AuthContext';

const Banner = () => {
  const { banners } = useAuth();
  if (!banners || banners.length === 0) return null;

  const concatenatedMessages = banners
    .map((banner, index) => (banners.length > 1 ? `${index + 1}. ${banner.message}` : banner.message))
    .join('   |   ');

  return (
    <div
      role='button'
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: colors.back21,
        padding: '12px',
      }}
    >
      <Info color='info' />
      <div
        style={{
          flex: 1,
          color: '#fff',
          fontFamily: 'SofiaSans-Regular',
          backgroundColor: colors.back21,
          padding: '12px',
        }}
      >
        <Marquee cssNamespace='hover-stop' text={concatenatedMessages} hoverStop spacing={20} />
      </div>
    </div>
  );
};

export default Banner;
